<template>
    <div class="tab-list-container">
        <div v-if="type === 'div'" class="type_div">
            <div class="tab-list-item" v-bind:class="{active: item.name === activeItemName}"
                 v-for="(item, index) in items" v-bind:key="index" @click="$emit('click', item.name)">
                <div>{{item.name}}</div>
            </div>
        </div>
        <router-link v-else class="tab-list-item" v-bind:class="{active: item.name === activeItemName}"
                     v-for="(item, index) in items" v-bind:key="index" :to="item.link">
            <div v-html="item.name" @click="$emit('click', item.name)">
            </div>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "TabList",
        props: {
            type:{
                type: String,
                default: 'link',
            },
            items: {
                required: true,
                type: Array
            },
            activeItemName: {
                required: true,
                type: String
            }
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>

    a {
        text-decoration: none;
        div{
            font-size: 15px;
        }
    }

    .type_div{
        display: flex;
        width: 100%;
        height: 100%;
        font-size: 15px;
    }

    .tab-list-container {
        height: 42px;
        width: 100%;
        background-color: white;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        border-bottom: solid 2px $pink;
    }

    .tab-list-item {
        color: $darkGrey;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        cursor: pointer;
    }

    .tab-list-item:not(:last-child) {
        border-right: solid 2px $lightGrey;
    }

    .active {
        background-color: $pink;
        color: white;
    }

</style>